module.exports = __webpack_public_path__ + "static/media/DocumentFrontExample.b40ff8ff.svg";